import * as React from 'react';
import { Global, css, useTheme } from '@emotion/react';

import type { Theme } from './theme';

/**
 * Global reset + document defaults + shared keyframes.
 * Mount once near the app root, inside <ThemeProvider>.
 * Manrope is loaded via <link> in static/index.html — an @import inside an
 * emotion Global is unreliable (must be the stylesheet's first rule).
 */
export function GlobalStyle() {
  const theme = useTheme() as Theme;
  return React.createElement(Global, {
    styles: css`
      *, *::before, *::after { box-sizing: border-box; }

      html, body {
        margin: 0;
        padding: 0;
        font-family: ${theme.font.sans};
        font-size: ${theme.fontSize.base};
        line-height: ${theme.lineHeight.base};
        color: ${theme.color.fg.default};
        background: ${theme.color.bg.default};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      button { font-family: inherit; }

      @keyframes lumen-spin { to { transform: rotate(360deg); } }
      @keyframes lumen-toast-in {
        from { opacity: 0; transform: translateX(20px); }
        to   { opacity: 1; transform: translateX(0); }
      }
      @keyframes lumen-fade-in { from { opacity: 0; } to { opacity: 1; } }
      @keyframes lumen-modal-in {
        from { opacity: 0; transform: translateY(8px) scale(0.98); }
        to   { opacity: 1; transform: translateY(0) scale(1); }
      }
    `,
  });
}
